import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { InitiativeStatus, InitiativeType } from '@types';

export type PatchInitiativesRequest = {
	initiativeIds: Array<number>;
	patchInitiativeDescription: {
		assignedTo?: number;
		description?: string;
		initiativeStatusId?: InitiativeStatus;
		initiativeTypeId?: InitiativeType;
		title?: string;
	};
};

export const patchInitiatives = createPatchEndpoint<PatchInitiativesRequest>('/api/v3/initiatives/');
